// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__ssDOw","slider":"Slider_slider__ses5Z","disabled":"Slider_disabled__8HUS9","labels":"Slider_labels__PglW5","desktop":"Slider_desktop__qYHWZ"};